import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { getAddressToDisplay, getValue } from 'core/utils';
import { QuoteEntityType } from 'quotes/enums';
import { IVendorQuote } from 'quotes/types';

interface IProps {
  quote: IVendorQuote;
  entityType?: QuoteEntityType;
}

export const SoldToInfo = ({ quote, entityType = QuoteEntityType.QUOTE }: IProps) => {
  const { t } = useTranslation();

  return (
    <InfoCard
      title={QuoteEntityType.QUOTE === entityType ? t('titleQuotedTo') : t('titleSoldTo')}
      items={[
        {
          label: getValue(quote, 'customerUserCompanyName') as string,
          value: [getValue(quote, 'customerUserName'), getValue(quote, 'customerUserPhone')],
        },
        {
          label: getValue(quote, 'soldToAddress.name') as string,
          value: getAddressToDisplay(quote?.soldToAddress),
        },
      ]}
    />
  );
};
